module.exports = __webpack_public_path__ + "img/aws-logo.01ae6f24.png";